import { Form } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useState } from 'react';
import { convertToNumber, isNumeric } from '../_helpers/_methods';

const FormPassword = ({
  placeholder,
  id,
  maxLength,
  isValidate,
  validation,
  disabled,
  defaultValue,
  register,
  passwordType = 'password'
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => setShowPassword(!showPassword);
  return (
    <div style={{ position: 'relative' }}>
      {passwordType === 'pin' ? (
        <Form.Control
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          defaultValue={defaultValue}
          maxLength={maxLength}
          {...register(id, isValidate && validation)}
          onChange={(e) => {
            if (isNumeric(e.target.value)) {
              return;
            } else {
              e.target.value = convertToNumber(e.target.value);
            }
          }}
          required={true}
          disabled={disabled}
        />
      ) : (
        <Form.Control
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          defaultValue={defaultValue}
          maxLength={maxLength}
          {...register(id, isValidate && validation)}
          disabled={disabled}
        />
      )}
      {showPassword ? (
        <FaEyeSlash className="password-eye" onClick={handleShowPassword} />
      ) : (
        <FaEye className="password-eye" onClick={handleShowPassword} />
      )}
    </div>
  );
};

export default FormPassword;
